import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MdSnackBar, MdSnackBarConfig, MdDialog, MdDialogRef } from '@angular/material';

import { Title } from '@angular/platform-browser';
import { FormBuilder, Validators } from "@angular/forms";
import { ListingService } from '../listing.service';
import { ActivityService } from '../../common/activity.service';
import { PackageService } from '../../common/package.service';
import { CreditService } from '../../common/credit.service';
import { CountryService } from '../../common/country.service';


@Component({
  selector: 'app-add-attendee',
  templateUrl: './add-attendee.component.html',
  styleUrls: ['./add-attendee.component.css', '../../app.component.css', '../admin.css'],
  providers: [ListingService, ActivityService, PackageService, CreditService, CountryService]
})
export class AddAttendeeComponent implements OnInit {
  public user: any;
  public onSave = new EventEmitter();
  eventId: any;
  userId: any;
  userType: any;
  infoArray: any;
  transType: any;
  errorMessage: any;
  packageId = 0;
  users: any;
  creditCard: any;
  currentStep = 1;
  payType = 'Card';
  cardUse = 'old';
  travelInfo = 0;
  balance=0;
  spinner: boolean = false;
  eventUserId: any;
  phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];


  billingStates: any;
  mainUser: any;
  countries: any;

  activities: any=[];

  constructor(private pageTitle: Title, private router: Router, public dialogRef: MdDialogRef<AddAttendeeComponent>, private formBuilder: FormBuilder, private ListingService: ListingService, private ActivityService: ActivityService, private packageService: PackageService, private snackBar: MdSnackBar, private creditService: CreditService, private countryService: CountryService) {

  }
  ngOnInit() {
    if (this.eventId && this.userId && this.userType) {
      this.getinfoattendee(this.eventId, this.userId);
    } else {
      this.snackBar.open('something went wrong!', '', { duration: 4000 });
      this.dialogRef.close();
    }



    this.users = {
      firstName: '',
      lastName: '',
      email: '',
      cellPhone: '',
      price: '',
      mainUser: this.userId,
      cardId: '',
      cardFrom: 'old',
      eventUser: {
        eventId: this.eventId,
        badgeName: '',
        firstName: '',
        lastName: '',
        cellPhone: '',
        type: this.userType,
        designation: 'Business Attendee',
        arriveByPlane: 0,
        arriveFlightName: '',
        arriveFlightNumber: '',
        arriveDateTime: '',
        arriveDateTime_: '',//new Date(),
        arriveNames: '',
        returnFlightName: '',
        returnFlightNumber: '',
        returnDateTime: '',
        returnDateTime_: '',// new Date(),
        returnNames: '',
        attendAwardCelebration: 1,
        userActivity: {
          userId: '',
          activityId: 0,
          transId: '123',
          questions: [],
          userQuestions: [],
          price: 0
        },
        price: '',
        mealRestriction: 0,
        mealChoice: 0,
        mealComments: '',
        parentEventUserId: this.eventUserId,
        busChargePersons: 0
      }
    };


    this.creditCard = {
      name: '',
      number: '',
      expMonth: '',
      expYear: '',
      cvv: '',
      cardType: 'visa',
      save: false,
      address1: '',
      address2: '',
      city: '',
      stateId: '',
      state: '',
      zip: '',
      countryId: '',
      country: '',
      sameAsUser: false
    };

    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
      for (var i = 0; i < this.countries.length; i++)
        if (this.countries[i].name == 'USA') {
          this.creditCard.countryId = this.countries[i].id;
          this.billingCountryChanged();
        }
    });

  }

  billingSameAsUser() {
    this.spinner = true;
    if (this.creditCard.sameAsUser) {
      this.creditCard.address1 = this.mainUser.eventUser.addressLine1;
      this.creditCard.address2 = this.mainUser.eventUser.addressLine2;
      this.creditCard.city = this.mainUser.eventUser.city;
      this.creditCard.stateId = this.mainUser.eventUser.stateId;
      this.creditCard.state = this.mainUser.eventUser.stateName;
      this.creditCard.countryId = this.mainUser.eventUser.countryId;
      this.countryService.getStates(this.mainUser.eventUser.countryId).subscribe(
        response => {
          this.spinner = false;
          this.billingStates = response;
        },
        error => {
          this.spinner = false;
        }
      );
      this.creditCard.country = this.mainUser.eventUser.countryName;
      this.creditCard.zip = this.mainUser.eventUser.zipcode;
    }
    else {
      this.spinner = false;
      this.creditCard.address1 = '';
      this.creditCard.address2 = '';
      this.creditCard.city = '';
      this.creditCard.stateId = '';
      this.creditCard.state = '';
      this.creditCard.countryId = '';
      this.creditCard.country = '';
      this.creditCard.zip = '';
    }
  }

  billingStateChanged() {
    for (var i = 0; i < this.billingStates.length; i++)
      if (this.billingStates[i].id == this.creditCard.stateId)
        this.creditCard.state = this.billingStates[i].name;
  }

  billingCountryChanged() {
    this.spinner = true;
    this.countryService.getStates(this.creditCard.countryId).subscribe(
      response => {
        this.spinner = false;
        this.billingStates = response;
      },
      error => {
        this.spinner = false;
        this.snackBar.open(error, '', { duration: 4000 });
      }
    );
    for (var i = 0; i < this.countries.length; i++)
      if (this.countries[i].id == this.creditCard.countryId)
        this.creditCard.country = this.countries[i].name;
  }


  validateZip(zip, country) {
    return true;
    // if (country == 'Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  total(fee, activityFee) {
    fee = (fee) ? fee : 0;
    activityFee = (activityFee) ? activityFee : 0;
    var tt = 0;
    tt = +fee + +activityFee;
    if (this.users.eventUser.arriveByPlane && this.users.eventUser.busChargePersons > 0)
      tt += (this.users.eventUser.busChargePersons * 50);
    this.users.eventUser.price = (+fee).toFixed(2);
    this.users.price = tt.toFixed(2);
    return tt.toFixed(2);
  }

  totalFloat(fee, activityFee) {
    return parseFloat(this.total(fee, activityFee));
  }

  cardType() {
    this.creditCard.cardType = this.creditService.parseCardType(this.creditCard.number);
  }

  dateTimeFormat(dt) {
    if (dt) {
      var m = dt.getMonth() + 1;
      if (m < 10)
        m = '0' + m;
      var d = dt.getDate();
      if (d < 10)
        d = '0' + d;
      return dt.getFullYear() + '-' + m + '-' + d + ' 00:00:00';
    }
    else
      return '';
  }

  usDateTimeFormat(dt) {
    if (dt) {
      if (typeof dt == 'string') {
        dt = dt.split(' ');
        dt = dt[0].split('-');
        return dt[1] + '/' + dt[2] + '/' + dt[0];
      }
      else {
        var m = dt.getMonth() + 1;
        if (m < 10)
          m = '0' + m;
        var d = dt.getDate();
        if (d < 10)
          d = '0' + d;
        return m + '/' + d + '/' + dt.getFullYear();
      }
    }
    else
      return '';
  }


  oldCard(id) {
    if (id) {
      this.users.cardId = id;
    }
  }

  cardFrom(type) {
    if (type) {
      this.users.cardFrom = type;
      if (type == 'new') {
        this.users.cardId = '';
      }
    }
  }

  continue(Id) {
    var flag = true;
    if (this.users.eventUser.designation == 'Business Attendee') {
      if (flag && !this.validateEmail(this.users.email)) {
        flag = false;
      }
      if (flag && !this.validatePhone(this.users.eventUser.cellPhone)) {
        flag = false;
      }
    } else {
      if (flag && this.users.email && !this.validateEmail(this.users.email)) {
        flag = false;
      }
      if (flag && this.users.eventUser.cellPhone && !this.validatePhone(this.users.eventUser.cellPhone)) {
        flag = false;
      }
    }

    if (this.users.eventUser.arriveByPlane == 1) {
      if(this.users.eventUser.arriveDateTime_!=''){
        if (flag && !this.users.eventUser.arriveHour) {
          flag = false;
        }
        if (flag && !this.users.eventUser.arriveMinutes) {
          flag = false;
        }
        if (flag && !this.users.eventUser.arriveAmPm) {
          flag = false;
        }
      }

      if(this.users.eventUser.returnDateTime_!=''){
        if (flag && !this.users.eventUser.returnHour) {
          flag = false;
        }
        if (flag && !this.users.eventUser.returnMinutes) {
          flag = false;
        }
        if (flag && !this.users.eventUser.returnAmPm) {
          flag = false;
        }
      }

    }


    if (flag && !this.users.eventUser.firstName) {
      flag = false;
    }
    if (flag && !this.users.eventUser.lastName) {
      flag = false;
    }
    if (flag && !this.users.eventUser.badgeName) {
      flag = false;
    }
    if (flag) {
      for (var i = 0; i < this.users.eventUser.userActivity.questions.length; i++) {
        if (!flag)
          break;
        if (this.users.eventUser.userActivity.questions[i].isMandatory == 1 && (this.users.eventUser.userActivity.questions[i].answerType == 'TextField' || this.users.eventUser.userActivity.questions[i].answerType == 'Radio') && !(this.users.eventUser.userActivity.userQuestions[i].answerText || this.users.eventUser.userActivity.userQuestions[i].answerId > 0))
          flag = false;
        for (var j = 0; j < this.users.eventUser.userActivity.questions[i].options.length; j++) {
          if (!flag)
            break;
          for (var k = 0; k < this.users.eventUser.userActivity.questions[i].options[j].questions.length; k++) {
            if (!flag)
              break;
            if (!this.users.eventUser.userActivity.questions[i].options[j].userQuestions[k])
              continue;
            if (this.users.eventUser.userActivity.questions[i].options[j].questions[k].isMandatory == 1 && (this.users.eventUser.userActivity.questions[i].options[j].questions[k].answerType == 'TextField' || this.users.eventUser.userActivity.questions[i].options[j].questions[k].answerType == 'Radio') && !(this.users.eventUser.userActivity.questions[i].options[j].userQuestions[k].answerText || this.users.eventUser.userActivity.questions[i].options[j].userQuestions[k].answerId > 0))
              flag = false;
          }
        }
      }
    }
    if (flag) {
      this.currentStep = Id;
    }
  }

  back() {
    this.currentStep = 1;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone) {
    var re = /^[0-9]{10}$/;
    return re.test(phone.replace(/-/g, ""));
  }

  getinfoattendee(eventId, userId) {
    this.spinner = true;
    this.ListingService.getInfoAttendee({ eventId: eventId, userId: userId, eventUserId: this.eventUserId }).subscribe(
      response => {
        this.spinner = false;
        this.infoArray = response;
        this.packageId = this.infoArray.packageInfo[0].id;
        this.cardUse = (this.infoArray.creditCard.length > 0) ? 'old' : 'new';
        this.travelInfo = this.infoArray.packageInfo[0].obtainTravel;
        this.transType = this.infoArray.packageInfo[0].transType;
        this.activities = this.infoArray.activity;
        for (var i = 0; i < this.activities.length; i++)
          this.activities[i].freeCount = 0;

        this.packageService.getActivityLimits({ packageId: this.packageId }).subscribe(response1 => {
          for (var i = 0; i < response1.length; i++)
            for (var j = 0; j < this.activities.length; j++)
              if (response1[i].activityId == this.activities[j].id) {
                this.activities[j].freeCount = response1[i].freeCount;
                break;
              }
        });

      },
      error => {
        this.spinner = false;
        this.errorMessage = <any>error;
      }
    );
  }



  activitySelected(userActivity) {
    this.spinner = true;
    userActivity.price = 0;
    userActivity.userQuestions = [];
    userActivity.questions = [];
    var usedCount = 0;
    var price = 0;
    var freeCount = 0;
    for (var i = 0; i < this.activities.length; i++)
      if (this.activities[i].id == userActivity.activityId) {
        userActivity.activityName = this.activities[i].name;
        price = parseFloat(this.activities[i].price);
        freeCount = this.activities[i].freeCount;
        break;
      }


    if (this.users.eventUser.userActivity.activityId == userActivity.activityId) {
      for (var i = 0; i < this.activities.length; i++)
        if (this.users.eventUser.userActivity.activityId == this.infoArray.usedActivity[i].id) {
          usedCount = this.infoArray.usedActivity[i].count;
          usedCount += 1;
          break;
        }
    }

    if (usedCount > freeCount)
      userActivity.price = price;

    this.ActivityService.getActivityQuestionsWithOptions({ activityId: userActivity.activityId }).subscribe(
      response => {
        this.spinner = false;
        userActivity.questions = response;
        userActivity.userQuestions = [];
        for (var i = 0; i < userActivity.questions.length; i++) {
          userActivity.userQuestions.push({ id: '', userId: userActivity.userId, questionId: userActivity.questions[i].id, answerId: 0, answerText: '', transId: '123', price: 0 });
          for (var j = 0; j < userActivity.questions[i].options.length; j++) {
            userActivity.questions[i].options[j].isPrice = parseInt(userActivity.questions[i].options[j].isPrice);
            for (var k = 0; k < userActivity.questions[i].options[j].questions.length; k++)
              for (var l = 0; l < userActivity.questions[i].options[j].questions[k].options.length; l++)
                userActivity.questions[i].options[j].questions[k].options[l].isPrice = parseInt(userActivity.questions[i].options[j].questions[k].options[l].isPrice);
          }
        }
      },
      error => {
        this.spinner = false;
      }
    );
  }


  optionSelected(params) {
    for (var i = 0; i < params.question.options.length; i++) {
      if (params.question.options[i].id == params.optionId && (params.userActivity.userQuestions[params.questionIndex].answerId == params.optionId || params.question.options[i].selected)) {
        params.question.options[i].userQuestions = [];
        for (var j = 0; j < params.question.options[i].questions.length; j++)
          params.question.options[i].userQuestions.push({ id: '', userId: params.userActivity.userId, questionId: params.question.options[i].questions[j].id, answerId: 0, answerText: '', transId: '123', price: 0 });
      }
    }

    if (params.userActivity.price)
      this.setPrice(params);
  }

  setPrice(params) {
    params.userActivity.userQuestions[params.questionIndex].price = 0;
    for (var i = 0; i < params.question.options.length; i++) {
      for (var j = 0; j < params.question.options[i].userQuestions.length; j++)
        params.question.options[i].userQuestions[j].price = 0.00;
      if (params.userActivity.userQuestions[params.questionIndex].answerId == params.question.options[i].id || params.question.options[i].selected) {
        if (params.question.options[i].isPrice) {
          if (params.question.answerType == 'Radio')
            params.userActivity.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if (params.question.answerType == 'Check')
            params.userActivity.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  subOptionSelected(params) {
    if (params.userActivity.price)
      this.setSubPrice(params)
  }

  setSubPrice(params) {
    params.option.userQuestions[params.questionIndex].price = 0;
    for (var i = 0; i < params.question.options.length; i++) {
      if (params.option.userQuestions[params.questionIndex].answerId == params.question.options[i].id || params.question.options[i].selected) {
        if (params.question.options[i].isPrice) {
          if (params.question.answerType == 'Radio')
            params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if (params.question.answerType == 'Check')
            params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  activityFee(activity) {
    var price = parseFloat(activity.price);
    for (var i = 0; i < activity.userQuestions.length; i++) {
      price += parseFloat(activity.userQuestions[i].price);
      for (var j = 0; j < activity.questions[i].options.length; j++) {
        for (var k = 0; k < activity.questions[i].options[j].userQuestions.length; k++)
          price += parseFloat(activity.questions[i].options[j].userQuestions[k].price);
      }
    }
    activity.totalPrice = price;
    return price.toFixed(2);
  }

  paymentFormValid(frm) {
    var flag = true;
    if (!frm.valid)
      flag = false;
    if (this.payType == 'Card' && this.users.cardFrom == 'new') {
      if (flag && !this.validateDigit(this.creditCard.number, 14, 19))
        flag = false;
      if (flag && !this.validateDigit(this.creditCard.expMonth, 2, 2))
        flag = false;
      if (flag && !this.validateDigit(this.creditCard.expYear, 2, 2))
        flag = false;
      if (flag && !this.validateDigit(this.creditCard.cvv, 3, 4))
        flag = false;
      if (flag && !this.creditCard.address1)
        flag = false;
      if (flag && !this.creditCard.city)
        flag = false;
      if (flag && !this.creditCard.stateId)
        flag = false;
      // if (flag && !this.creditCard.zip)
      //   flag = false;
      if (flag && !this.creditCard.countryId)
        flag = false;


    }
    return flag;
  }

  addAtt(attendeeForm) {
    if (attendeeForm.valid && this.paymentFormValid(attendeeForm)) {
      this.spinner = true;
      this.users.eventUser.arriveDateTime = (this.users.eventUser.arriveDateTime_!='')?this.dateTimeFormat(this.users.eventUser.arriveDateTime_):'';
      this.users.eventUser.returnDateTime = (this.users.eventUser.returnDateTime_!='')?this.dateTimeFormat(this.users.eventUser.returnDateTime_):'';
      this.cardType();
      this.ListingService.addAttendee({ users: this.users, creditCard: this.creditCard, payType: this.payType }).subscribe(
        response => {
          this.spinner = false;
          if (response.status) {
            this.snackBar.open('Attendee added Successfully', '', { duration: 4000 });
            this.dialogRef.close(response.status);
          }
          else
            this.snackBar.open(response.msg, '', { duration: 4000 });
        },
        error => {
          this.spinner = false;
        }
      );
    }
  }

  validateDigit(num, min, max) {
    return num.match("^[0-9]{" + min + "," + max + "}$");
  }

  close() {
    this.dialogRef.close();
  }

  triggerClick(id) {
    (<HTMLInputElement>window.document.getElementById(id)).click()
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/add-attendee/add-attendee.component.ts